import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../constants/common'
import {
  getNewsboardPostProfileHeaderEditTitleMaxLength,
  NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME,
} from '../NewsboardPostProfileHeaderEditTitleField'

export function getNewsboardPostProfileHeaderEditTitleInitialValues(title) {
  return {
    [NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME]:
      title || EMPTY_STRING,
  }
}

export function getNewsboardPostProfileHeaderEditTitleValidationSchema(
  t,
  isTicker
) {
  const maxLength = getNewsboardPostProfileHeaderEditTitleMaxLength(isTicker)

  return Yup.object({
    [NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME]: Yup.string()
      .trim()
      .required(true)
      .max(
        maxLength,
        t('Error.MaxLengthKey', {
          length: maxLength,
        })
      ),
  })
}
